import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { BUILDING_TYPE_HOUSE } from '../../../../marietta/webcad/Constants';

/**
 * 廊下自動生成確認ダイアログ
 * 廊下自動生成ボタン押下時に表示
 */
class ConfirmGenerateHallwayDialog extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'confirmGenerateHallwayDialog';
    const title = '';

    const { currentFloor } = marietta.webcad.WebCADGlobal.webcad2Dmanager;
    let contents = '<div class="confirmGenerateHallway">\n';
    if( marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType == BUILDING_TYPE_HOUSE ){
      contents += `<span class="jp">${currentFloor}階の廊下を全て削除し、廊下の自動生成を行いますか？<br><br>※2階以上は、あらかじめ下階に階段を配置してください。</span><span class="en">Would you like to delete all the hallways on ${currentFloor}F and run the auto hallway generation?<br><br>*Please make sure to input the down stair staircase when operating the 2nd floor and up.</span>`;
    }else {
      contents += `<span class="jp">廊下を全て削除し、廊下の自動生成を行いますか？</span><span class="en">Would you like to delete all the hallways and run the auto hallway generation?</span>`;
    }
    contents += '</div>\n';

    let footer = '<button value="true"><span class="jp">はい</span><span class="en">Yes</span></button>';
    footer += '<button><span class="jp">いいえ</span><span class="en">No</span></button>';

    this.createDialog(id, title, contents, footer);

    this.viewObj.querySelectorAll('button').forEach((element) => {
      element.addEventListener('click', this.btnEventHandler);
    });
  }

    /**
     * ボタンがクリックされた
     */
    btnEventHandler = (e) => {
      e.preventDefault();
      if ((e.currentTarget).value) {
        marietta.webcad.WebCADGlobal.cadAPIManager.generateHallways();
      }
      this.close();
    }
}

export default ConfirmGenerateHallwayDialog;
